export const getRecommendedPosts = state => state.recommendedPosts.posts



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/recommendedPosts/recommendedPosts.selectors.js